<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import type { ISearch } from '../interfaces/search.interface'
    import SearchPager from './Pager.svelte'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    let searchList: ISearch[] = []
    let total = 0
    let error = false
    let processing = false

    serviceProvider.searchService.searchListSubs.subscribe((list) => (searchList = list))
    serviceProvider.searchService.totalSubs.subscribe((number) => (total = number))
    serviceProvider.searchService.errorSubs.subscribe((status) => (error = status))
    serviceProvider.searchService.processingSubs.subscribe((status) => (processing = status))
</script>

{#if processing}
    <h2>Vyhledávám...</h2>
{:else if error}
    <h2>Výsledky vyhledávání</h2>
    <p>Nastala chyba při vyhledávání</p>
{:else}
    <h2>Výsledky {total} vyhledávání</h2>
    {#if searchList.length}
        <div class="bno-search-list">
            <ul class="bno-search-list__items">
                {#each searchList as item}
                    <li class="bno-search-list__item">
                        <h4><a href={item.url}>{item.title}</a></h4>
                        {#if item.description}
                            {@html item.description}
                        {/if}
                        {#if item.categories && item.categories.length}
                            <nav class="bno-breadcrumbs">
                                <ol class="bno-breadcrumbs__list">
                                    {#each item.categories as category}
                                        <li class="bno-breadcrumbs__item">
                                            <span>{category.title}</span>
                                        </li>
                                    {/each}
                                </ol>
                            </nav>
                        {/if}
                    </li>
                {/each}
            </ul>
        </div>
        <SearchPager {serviceProvider}/>
    {:else}
        <p>Vašemu zadání neodpovídají žádné výsledky</p>
    {/if}
{/if}
